/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_IntroInputs */

const en_claims_intro = /** @type {(inputs: Claims_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you require medical care while studying, it is critical that you contact AF24 Claims and Assistance before seeking treatment. In a serious medical emergency, get to a hospital immediately and have a family member or friend call AF24 on your behalf within 24 hours of admission and before any surgery is performed.`)
};

const fr_claims_intro = /** @type {(inputs: Claims_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si vous avez besoin de soins médicaux pendant vos études, il est essentiel de contacter AF24 Claims and Assistance avant de chercher un traitement. En cas d'urgence médicale grave, rendez-vous immédiatement à l'hôpital et demandez à un membre de votre famille ou un ami d'appeler AF24 en votre nom dans les 24 heures suivant l'admission et avant toute chirurgie.`)
};

/**
* | output |
* | --- |
* | "If you require medical care while studying, it is critical that you contact AF24 Claims and Assistance before seeking treatment. In a serious medical emergen..." |
*
* @param {Claims_IntroInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_intro = /** @type {((inputs?: Claims_IntroInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_IntroInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_intro(inputs)
	return fr_claims_intro(inputs)
});